import { ITipoRelacaoCliente } from "../../../../Interfaces/Geral/GestaoDeCadastro/TipoRelacaoCliente/TipoRelacaoClienteInterface";
import {
    AlterarTipoRelacaoClienteService,
    ListarTipoRelacaoClienteService,
} from "../../../../Services/Geral/GestaoDeCadastros/TipoRelacaoCliente/TipoRelacaoClienteServices";
import { Controller } from "../../../Controller";

export async function ListarTipoRelacaoClienteController() {
    return Controller(ListarTipoRelacaoClienteService());
}

export async function AlterarTipoRelacaoClienteController(
    requestBody: ITipoRelacaoCliente
) {
    return Controller(AlterarTipoRelacaoClienteService(requestBody));
}
